<div class="list-data" [ngClass]="{'hidden': options?.length === 0}">
    <p-listbox emptyMessage=" " [options]="options" [(ngModel)]="selectedValue" (onClick)="onOrderTemplateSelection($event)">
        <ng-template let-data pTemplate="item">
            <div class="w-full flex-body">
                <span class="m-r-8">{{data.name}}
                    <span class="default-text green" *ngIf = "data.isDefaultOrderingService" >{{'DEFAULT' | translate}}</span>
                </span>
            </div>
        </ng-template>
    </p-listbox>
</div>
<label *ngIf="options && !(options.length > 0)"
    class="no-data-msg">{{'vbeiNoOrderTemplateFoundError' | translate}}</label>
<label [ngClass]="{hidden: (options && (options.length > 0 || options.length <= 0))}" class="no-data-msg">{{'vbeLoading' | translate}}</label>
